export default __webpack_public_path__ + "static/media/IMG-20211119-WA0025-01-01.f8e05bf7.jpeg";